window.imageFocus = require('image-focus').FocusedImage
